import type { ModelId } from '@/types'

export type ModelType = 'basic' | 'standard' | 'premium'

// Model + duration to API model mapping
export const MODEL_MAP: Record<string, ModelId> = {
  'basic-5': 'ws_480p_i2v_5s',
  'standard-5': 'ws_720p_i2v_5s',
  'standard-10': 'ws_720p_i2v_10s',
  'premium-5': 'wan_2_5_i2v_5s',
  'premium-10': 'wan_2_5_i2v_10s',
}

export const CREDIT_COSTS: Record<ModelId, number> = {
  qwen_image: 5,
  qwen_image_lora: 5,
  qwen_image_edit: 5,
  wan_2_2_t2i_realism: 5,
  wan_2_2_animate_5s: 75,
  wan_2_2_i2v_3s: 35,
  ws_480p_i2v_5s: 35,
  wan_2_2_i2v_6s: 75,
  wan_2_2_i2v_12s: 140,
  wan_2_5_i2v_5s: 75,
  wan_2_5_i2v_10s: 150,
  wan_2_6_t2v_5s: 120,
  ws_720p_i2v_5s: 75,
  ws_720p_i2v_10s: 140,
}

export function getModelId(model: ModelType, duration: string): ModelId {
  return MODEL_MAP[`${model}-${duration}`] ?? 'ws_480p_i2v_5s'
}

export const LOCALSTORAGE_KEY = 'pixelmaker_i2v_data'
